import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MasterService } from 'src/app/masters/master.service';
import { LoaderService } from 'src/app/common/loader.service';
import * as CommonConstants from '../../utils/common.constants';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/utils/shared.service';
import * as moment from 'moment';
@Component({
  selector: 'app-followup',
  templateUrl: './followup.component.html',
  styleUrls: ['./followup.component.scss']
})
export class FollowupComponent implements OnInit {
  @Input() medFileId;
  medServicePlan=[];
  medLogisticServicePlan=[];
  medDocRetrieve=[];
  PARAM_KEY = [CommonConstants.STATUS, CommonConstants.PATIENT_CONDITION, CommonConstants.MED_URGENCY];
  PARAM__CODE_KEY = [CommonConstants.STATUS, CommonConstants.SUBJECTIVE_SIGN, CommonConstants.OBJECTIVE_SIGN,CommonConstants.SERVICE_CATEGORY ];
  SERVICE_KEYS = [CommonConstants.MED_SERVICE_PLAN, CommonConstants.MED_LOGISTIC_SERVICE_PLAN, CommonConstants.MED_DOC_RETRIEVE];
  medServicePlanForm: FormGroup;
  medDocRetrieveForm: FormGroup;
  medLogisticPlanForm: FormGroup;
  submitted: boolean;
  masterValues: any;
  sCategory: any;
  status: any;
  sSubCategory: any;
  masterCodes: any;
  constructor(private modal: NgbModal,private fb: FormBuilder, private medicalFileService: MedicalFileService, private masterService: MasterService
    , private toastrService: ToastrService, private sharedService: SharedService, private modalService: BsModalService, private loaderService: LoaderService) { 
    this.getMedServicePlanGroup();
    this.getMedLogisticServicePlanGroup();
    this.getMedDocRetrieveGroup();
  }

  ngOnInit() {
    this.loadMaster();
    this.loadFollowpDetails();
  }
  medicalServiceAddModal(medicalService) {
    this.medServicePlanForm.reset();
    this.modal.open(medicalService, { size: 'lg', container: '.page-content' });
  }
  logisticServiceAddModal(logisticService) {
    this.medLogisticPlanForm.reset();
    this.modal.open(logisticService, { size: 'lg', container: '.page-content' });
  }
  documentRetrieveAddModal(documentRetrieve) {
    this.medDocRetrieveForm.reset();
    this.modal.open(documentRetrieve, { size: 'lg', container: '.page-content' });
  }
  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.status = this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
      }
    });
    this.masterService.getMastersCodesByParamKey(this.PARAM__CODE_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterCodes = response['result'];
        this.sCategory = this.masterCodes.filter(master => master.paramKey === CommonConstants.SERVICE_CATEGORY && master.parentId===0);
      }
    });
  }
  onChangecategory(event){
    this.sSubCategory=[];
    this.sSubCategory = this.masterCodes.filter(master => master.paramKey === CommonConstants.SERVICE_CATEGORY && master.parentId===event.id);
  }
  loadFollowpDetails(){
    this.medicalFileService.getDetailsByKeys(this.medFileId, this.SERVICE_KEYS).subscribe(response => {
      if(response["code"]=="S0000" && response["result"]){
        let followupList=response["result"];
        this.medDocRetrieve=followupList[CommonConstants.MED_DOC_RETRIEVE];
        this.medLogisticServicePlan=followupList[CommonConstants.MED_LOGISTIC_SERVICE_PLAN];
        this.medLogisticServicePlan = this.medLogisticServicePlan.map(item => ({
          ...item,
          statusDesc: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null,
          catDesc: item.srvcaId ? this.sCategory.find(obj => +obj.id === +item.srvcaId).value : null,
          subCatDesc: item.srvcaIdSub ? this.sSubCategory.find(obj => +obj.id === +item.srvcaIdSub).value : null,
        })); 
        this.medServicePlan=followupList[CommonConstants.MED_SERVICE_PLAN];
        this.medServicePlan = this.medServicePlan.map(item => ({
          ...item,
          statusDesc: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null,
          catDesc: item.srvcaId ? this.sCategory.find(obj => +obj.id === +item.srvcaId).value : null,
          subCatDesc: item.srvcaIdSub ? this.sSubCategory.find(obj => +obj.id === +item.srvcaIdSub).value : null,
        })); 
      }
    },
    error => {
      swal.fire("Error", "Error Occured While Fetching Follow up Details", 'error');
    })
  }
  getMedServicePlanGroup(){
    this.medServicePlanForm = this.fb.group({
    'medspId':[],
    'medfiId':[],
    'medspDescription':new FormControl(),
    'medspPlace':new FormControl(),
    'medspReqDate':new FormControl(),
    'medspSpecialist':new FormControl(),
    'patieId':new FormControl(),
    'srvcaId':new FormControl(),
    'srvcaIdSub':new FormControl(),
    'staRecCode':[],
    'statuCode':new FormControl()
  })
  }
  getMedLogisticServicePlanGroup(){
    this.medLogisticPlanForm = this.fb.group({
    'logspId':[],
    'medfiId':[],
    'logspBeneficiary':new FormControl(),
    'logspDtFrom':new FormControl(),
    'logspDtTo':new FormControl(),
    'logspReqDate':new FormControl(),
    'patieId':new FormControl(),
    'srvcaId':new FormControl(),
    'srvcaIdSub':new FormControl(),
    'staRecCode':[],
    'statuCode':new FormControl()
  })
  }
  getMedDocRetrieveGroup(){
    this.medDocRetrieveForm= this.fb.group({
    'docreId':[],
    'medfiId':[],
    'docreDescription':new FormControl(),
    'docreEditor':new FormControl(),
    'docreReqDate':new FormControl(),
    'docreRetrieveDate':new FormControl(),
    'docreServiceDate':new FormControl(),
    'dotypId':new FormControl(),
    'srvcaIdSub':new FormControl(),
    'patieId':new FormControl(),
    'staRecCode':[],
    'statuCode':new FormControl()
  })
  }
  saveMedServicePlan() {
    this.submitted = true;
    if (this.medServicePlanForm.invalid) {
      return;
    }
    let jsonData = this.medServicePlanForm.value;
    jsonData["medspReqDate"]=this.medServicePlanControls.medspReqDate.value ? this.sharedService.getDateFormat(this.medServicePlanControls.medspReqDate.value) : null;
    jsonData["medfiId"]=this.medFileId;
    this.loaderService.display(true);
    this.medicalFileService.saveMedServicePlan(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
        if(this.medServicePlan && this.medServicePlan.length > 0){
          this.medServicePlan=this.medServicePlan.filter(plan => plan.medspId !== response.medspId);
        }
        this.medServicePlan.push(response);
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Medical Service plan", 'error');
    })
  }
  saveMedLogisticServicePlan() {
    this.submitted = true;
    if (this.medLogisticPlanForm.invalid) {
      return;
    }
    let jsonData = this.medLogisticPlanForm.value
    jsonData["logspReqDate"]=this.medLogisticServicePlanControls.logspReqDate.value ? this.sharedService.getDateFormat(this.medLogisticServicePlanControls.logspReqDate.value) : null;
    jsonData["logspDtFrom"]=this.medLogisticServicePlanControls.logspDtFrom.value ? this.sharedService.getDateFormat(this.medLogisticServicePlanControls.logspDtFrom.value) : null;
    jsonData["logspDtTo"]=this.medLogisticServicePlanControls.logspDtTo.value ? this.sharedService.getDateFormat(this.medLogisticServicePlanControls.logspDtTo.value) : null;
    jsonData["medfiId"]=this.medFileId;
    this.loaderService.display(true);
    this.medicalFileService.saveMedLogisticServicePlan(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
        if(this.medLogisticServicePlan && this.medLogisticServicePlan.length > 0){
          this.medLogisticServicePlan=this.medLogisticServicePlan.filter(plan => plan.logspId !== response.logspId);
        }
        this.medLogisticServicePlan.push(response);
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Medical Losgistc Service Plan", 'error');
    })
  }
  saveMedDocRetrieve() {
    this.submitted = true;
    if (this.medDocRetrieveForm.invalid) {
      return;
    }
    this.medDocRetrieveForm.value.medfiId = this.medFileId;
    let jsonData = this.medDocRetrieveForm.value;
    this.loaderService.display(true);
    this.medicalFileService.saveMedDocRetrieve(jsonData).subscribe(res => {
      this.loaderService.display(false);
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'], 'success');
        this.medDocRetrieve.push(response);
        this.modal.dismissAll();
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Second Opinion", 'error');
    })
  }
  reset(){
    this.medDocRetrieveForm.reset();
    this.medLogisticPlanForm.reset();
    this.medServicePlanForm.reset();
  }
  get medServicePlanControls() { return this.medServicePlanForm.controls; }
 onMedServicePlanSelect(event,medicalService){
  let medServicePlan = event.data;
  this.medServicePlanForm.patchValue({});
  Object.keys(medServicePlan).forEach(name => {
    if (medServicePlan[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name) && name!="statusDesc" && name!="catDesc" && name!="subCatDesc") {
      if (name === "statuCode" || name === "srvcaId" || name === "srvcaIdSub" ) {
        this.medServicePlanControls[name].patchValue(+medServicePlan[name]);
      }else{
        this.medServicePlanControls[name].patchValue(medServicePlan[name]);
      }
       
    }
  });
  this.modal.open(medicalService, { size: 'lg', container: '.page-content' });
}
get medLogisticServicePlanControls() { return this.medLogisticPlanForm.controls; }
 onMedLogisticServicePlanSelect(event,logisticPlan){
  let medLogistic = event.data;
  this.medLogisticPlanForm.patchValue({});
  Object.keys(medLogistic).forEach(name => {
    if (medLogistic[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name) && name!="statusDesc" && name!="catDesc" && name!="subCatDesc") {
      if (name === "statuCode" || name === "srvcaId" || name === "srvcaIdSub" ) {
        this.medLogisticServicePlanControls[name].patchValue(+medLogistic[name]);
      } else {
        this.medLogisticServicePlanControls[name].patchValue(medLogistic[name]);
      }
    }
  });
  this.modal.open(logisticPlan, { size: 'lg', container: '.page-content' });
}
get docRetrieveControls() { return this.medDocRetrieveForm.controls; }
 onMedDocRetreiveSelect(event,medDocRetrieve){
  let docRtrve = event.data;
  this.medDocRetrieveForm.patchValue({});
  Object.keys(docRtrve).forEach(name => {
    if (docRtrve[name] && !CommonConstants.AUDITABLE_ENTITY.includes(name)) {
      if (name === "statuCode" || name === "dotypId") {
        this.docRetrieveControls[name].patchValue(+docRtrve[name]);
      }else{
        this.docRetrieveControls[name].patchValue(docRtrve[name]);
      }
        
    }
  });
  this.modal.open(medDocRetrieve, { size: 'lg', container: '.page-content' });
}
}
